import './App.css';
// import About from './components/About';
import Navbar from './components/Navbar';
import React, { useState } from 'react';
import TextForm from './components/TextForm';
// import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';



function App(){ 
  const[mode, setmode] =  useState('light');
  const[colour, setcolour] = useState('off');
  const[colour2, setcolour2] = useState('off');

  const toggleMode = () =>{
    if(mode === 'light'){
      setmode('dark');
      document.body.style.backgroundColor = 'black';
      document.body.style.color = 'white';
    }
    else{
      setmode('light');
      document.body.style.backgroundColor = 'white';
      document.body.style.color = 'black';
    }
  }

  const togglered = () => {
    if (colour === 'off') {
      setcolour('on');
      if (mode === 'light') {
        document.body.style.backgroundColor = '#ffcccb';
        document.body.style.color = 'black';
      } else {
        document.body.style.backgroundColor = '#8B0000';
        document.body.style.color = 'white';
      }
    } else {
      setcolour('off');
      if (mode === 'light') {
        document.body.style.backgroundColor = 'white';
        document.body.style.color = 'black';
      } else {
        document.body.style.backgroundColor = 'black';
        document.body.style.color = 'white';
      }
    }
  }

  const toggleblue = () => {
    if (colour2 === 'off') {
      setcolour2('on');
      if (mode === 'light') {
        document.body.style.backgroundColor = '#ADD8E6';
        document.body.style.color = 'black';
      } else {
        document.body.style.backgroundColor = '#00BFFF';
        document.body.style.color = 'white';
      }
    } else {
      setcolour2('off');
      if (mode === 'light') {
        document.body.style.backgroundColor = 'white';
        document.body.style.color = 'black';
      } else {
        document.body.style.backgroundColor = 'black';
        document.body.style.color = 'white';
      }
    }
  }

  return (
    <>
    {/* <Router> */}
    <Navbar title = "TextUtils" mode={mode} toggleMode={toggleMode} togglered = {togglered} toggleblue = {toggleblue}/>
    <div className="container my-3" >
      {/* <Routes>
        <Route exact path="/about" element={<About />} />
        <Route exact path="/" element={<TextForm heading="Enter the desired text" mode={mode} />} />
      </Routes> */}
      <TextForm heading="Enter the desired text" mode={mode} />
    </div>
    {/* </Router> */}
    
    </>
  );
}

export default App;
